import React, { useEffect, useState } from "react";
import styles from "./imageCropper.module.scss";
import Cropper from "react-easy-crop";
import getCroppedImg from "./cropImage";

const aspectRatios = [
    { value: 1, text: "1:1" },
    { value: 4 / 3, text: "4:3" },
    { value: 16 / 9, text: "16:9" },
]

const ImageCropper = ({id, imageUrl, zoomInit, aspectInit, cropInit, onCancel, setCroppedImageFor}) => {
    if(zoomInit === null || zoomInit === undefined) zoomInit = 1;
    if(aspectInit === null || aspectInit === undefined) aspectInit = aspectRatios[0];
    if(cropInit === null || cropInit === undefined) cropInit = { x: 0, y: 0 };

    const [zoom, setZoom] = useState(zoomInit);
    const [crop, setCrop] = useState(cropInit);
    const [aspect, setAspect] = useState(aspectInit);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);


    const onCropChange = (crop) => {
        setCrop(crop);
    };

    const onZoomChange = (zoom) => {
        setZoom(zoom);
    };

    const onAspectChange = (e) => {
        const value = e.target.value;
        const ratio = aspectRatios.find((ratio) => ratio.value == value);
        setAspect(ratio);
    };

    const onCropComplete = (croppedArea, croppedAreaPixels) => {
        setCroppedAreaPixels(croppedAreaPixels);
    };

    const onCrop = async () => {
        const croppedImageUrl = await getCroppedImg(imageUrl, croppedAreaPixels);
        setCroppedImageFor(zoom, aspect, crop, croppedImageUrl, id);
    };



    return (
        <div>
       <div className={styles.backDrop}></div>
                <div className={styles.cropContainer}> 
                <Cropper 
                image={imageUrl}
                crop={crop}
                zoom={zoom}
                aspect={aspect.value}
                onCropChange={onCropChange}
                onZoomChange={onZoomChange}
                onCropComplete={onCropComplete}
                classes={{ mediaClassName: styles.cropContainer_media }}
                />
                </div>
                <div className={styles.controls}>
                    <div className={styles.slideContainer}>
                        <label>Zoom</label>
                        <input
                            type="range"
                            min={1}
                            max={3}
                            step={0.1}
                            value={zoom}
                            onInput={(e) => onZoomChange(e.target.value)}
                            className={styles.slider}
                        />
                        <select onChange={onAspectChange}>
                        {aspectRatios.map((ratio) => (
                            <option 
                                key={ratio.text}
                                value={ratio.value}
                                selected={ratio.value === aspect.value}>
                                    {ratio.text}
                                </option>
                        ))}
                        </select>
                        <div className={styles.buttonContainer}>
                                            <button onClick={onCancel}>Cancelar</button>
                                            <button onClick={onCrop} >Guardar</button>
                                            <button >Resetear</button>
                                            </div>
                    </div>
                </div>
                    
        </div>

    );
}

export default ImageCropper;